"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createReactBindings = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var ReactiveMapProvider_1 = require("./components/ReactiveMapProvider");
var SlicesProvider_1 = require("./components/SlicesProvider");
function isFunction(value) {
    return typeof value === 'function';
}
function createReactBindings() {
    var TypedReativeMapContext = ReactiveMapProvider_1.ReactiveMapContext;
    function useReactiveMapContextOrInstance(reactiveMapInstance) {
        var reactiveMap = (0, react_1.useContext)(TypedReativeMapContext) || reactiveMapInstance;
        if (!reactiveMap) {
            throw new Error('No ReactiveMap found in the context nor it was passed as an argument.');
        }
        return reactiveMap;
    }
    function useShareStateCallback(item) {
        return (0, react_1.useCallback)(function (newValue) {
            if (isFunction(newValue)) {
                item.set(newValue(item.get()));
            }
            else {
                item.set(newValue);
            }
        }, [item]);
    }
    function useReadSharedState(key, options) {
        if (options === void 0) { options = {}; }
        return useSharedState(key, options)[0];
    }
    function useWriteSharedState(key, _a) {
        var _b = _a === void 0 ? {} : _a, initialiser = _b.initialiser, reactiveMap = _b.reactiveMap;
        var item = useReactiveMapContextOrInstance(reactiveMap).item(key, {
            initialiser: initialiser,
        });
        return useShareStateCallback(item);
    }
    function useSharedState(key, _a) {
        if (_a === void 0) { _a = {}; }
        var initialiser = _a.initialiser, restOptions = tslib_1.__rest(_a, ["initialiser"]);
        var reactiveMap = useReactiveMapContextOrInstance(restOptions.reactiveMap);
        var item = reactiveMap.item(key, { initialiser: initialiser });
        var shareState = useShareStateCallback(item);
        var _b = tslib_1.__read((0, react_1.useState)(item.get()), 2), value = _b[0], setLocalState = _b[1];
        var _c = tslib_1.__read((0, react_1.useState)(item.error), 2), error = _c[0], setError = _c[1];
        var _d = tslib_1.__read((0, react_1.useState)(item.loading), 2), loading = _d[0], setLoading = _d[1];
        (0, react_1.useEffect)(function () {
            setLocalState(item.get());
            return item.listen(function (value, currentError) {
                setLocalState(value);
                setError(currentError);
                setLoading(item.loading);
            });
        }, [item]);
        return [value, shareState, { setLocalState: setLocalState, loading: loading, error: error }];
    }
    return {
        useSharedState: useSharedState,
        useReadSharedState: useReadSharedState,
        useWriteSharedState: useWriteSharedState,
        SlicesProvider: SlicesProvider_1.SlicesProvider,
        useReactiveMap: ReactiveMapProvider_1.useReactiveMap,
    };
}
exports.createReactBindings = createReactBindings;
//# sourceMappingURL=createReactBindings.js.map